import React from "react";
import { Box, Typography } from "@mui/material";
import CustomSubmitButton from "../CustomSubmitButton/CustomSubmitButton";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import animationData from "../../Utils/congratulation.json";
const CustomModal = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bgcolor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9998,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '400px',
          bgcolor: '#fff',
          boxShadow: 24,
          padding: '20px 20px',
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          zIndex: 9999,
        }}
      >
        <Box sx={{ width: '200px', margin: '0 auto' }}>
          {/* <img
            src="/Congratulations.gif"
            alt="well_done_img"
            style={{
              width: '100%',
              objectFit: 'contain'
            }}
          /> */}
          <Lottie
            animationData={animationData}
            loop={true}
            
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "20px",
            fontWeight: "700",
            fontFamily: "Poppins",
            textAlign: "center",
            padding: '15px 0px 0px 0px',
          }}
        >
          Thank You for
          Submitting
          A New
          Lead!
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            padding: '15px 0px 0px 0px',
            gridGap: '10px'
          }}
        >
          <CustomSubmitButton
            type="button"
            btnTitle="Lead Status"
            sx={{
              fontSize: '14px',
              padding: "12px 8px",
            }}
            onSubmit={() => navigate('/create-daily-sheet')}
          />
          <CustomSubmitButton
            type="button"
            btnTitle="Scoreboard"
            sx={{
              fontSize: '14px',
              padding: "12px 8px",
            }}
            onSubmit={() => navigate('/leader-board')}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomModal;
